<template>
  <DBox
    :id="'cmp-booking-artists-external_calendars'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="$t('add_new_external_calendar')"
    @add_click="addExternalCalendar"
  >
    <NTable
      class="invcoie-line-list dbox1"
      :headers="headers"
      :items="external_links"
      :config="tableConfig"
      :id="'dtplugins-dbox_files'"
      :showNoItems="false"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('description')">
            <span class="txtov">{{ item.description }}</span>
          </td>
          <td v-bind="tdcon('link')">
            <span class="txtov"
              ><a
                class="ut-link ut-text-accent5"
                :href="item.external_link"
                target="_blank"
              >
                {{ item.external_link }}
              </a></span
            >
          </td>
          <td v-bind="tdcon('options')">
            <div class="dt-icon-container">
              <img
                src="static/icons/delete.svg"
                class="dt-icon v5 s1"
                @click="(e) => onExternalCalendarDelete(item)"
                :alt="$t('delete_external_link')"
                :title="$t('delete_external_link')"
              />
            </div>
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>
<script>
import { confirmDelete } from "../../../../../dt-plugins/confirmation/confirmation-common";
import {
  closeModalRoute,
  createModalMixin,
  openModalRoute,
  openModalRoute2,
} from "../../../../../dt-plugins/modal/modal.mixin";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../../plugins/datatable";
import { ArtistService } from "../../../services/artists";

export default {
  components: {},
  props: ["external_links"],
  mixins: [createModalMixin("addExternalCalendar")],
  data() {
    return {
      tableConfig: createNTableConfig({
        headerStyle: 3,
        rowHeight: 28,
        fullHeight: true,
        showHeader: true,
      }),
    };
  },
  computed: {
    headers: function () {
      return [
        createTableHeader("description"),
        createTableHeader("link", { f: 2 }),
        createTableHeader("options", { text: false, mw: 30 }),
      ];
    },
  },
  methods: {
    addExternalCalendar() {
      openModalRoute2(this, "addExternalCalendar");
    },
    async onExternalCalendarDelete(item) {
      const deleteResult = await confirmDelete(
        "External Link",
        item.description
      );
      if (deleteResult == "OK") {
        this.$emit("delete", item);
      }
    },
    //MARK: methods
  },
};
</script>
<style lang="scss"></style>
